import { render, staticRenderFns } from "./Seccion_productos.vue?vue&type=template&id=16cf0b42&lang=pug&"
import script from "./Seccion_productos.vue?vue&type=script&lang=js&"
export * from "./Seccion_productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports